export const ERROR = "error";
export const WARNING = "warning";
export const DANGER = "danger";
export const LEVEL_WARNING = "Warning";
export const LEVEL_ERROR = "Error";
